import React from 'react';
import {
  FDEmptyState, FDPaper, FDStack,
} from '@facet-wealth/design';

export const NoAttachment = () => {
  return (
    <FDPaper appearance={'outlined'} width={'100%'} height={'100%'} padding={4}>
      <FDStack direction={'column'} alignItems={'center'} justifyContent={'center'} height={'100%'}>
        <FDEmptyState title={'No attachment'} icon={'fileCopy'} />
      </FDStack>
    </FDPaper>
  );
};
